module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/ec-7be6ca137c0a396154ac29e4a1fcc6b5.svg";